import { CheckOutlined, CloseOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, PrinterOutlined, SaveOutlined, SendOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, FloatButton, Form, Input, Modal, Row, Space, Tabs, Upload, UploadFile, UploadProps } from "antd";
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import ModalTextForm from "../../components/modal/ModalTextForm";
import Summernote from '../../components/summernote/Summernote';
import { trangThaiDangKyDaoTao, trangThaiTongHopDangKyDaoTao, urlAdmin } from "../../constants";
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, shortFileName, validateMessages } from '../../helpers/common';
import { QDBLRequest } from '../../models/hopdong/HopDong';
import { duyetChiTietTongHopDKDT, layChiTietDangKyDaoTaoNam, luuBanHanhDangKyDaoTao, luuNoiDungDangKyDaoTaoNam, pheDuyetTongHopDKDT, xoaDangKyDaoTaoNam, xuatKeHoachDaoTaoNam, xuatPhieuTrinhDaoTaoNam } from "../../services/daotao";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LogNguoiDungTable from "../utils/LogNguoiDungTable";
import BoSungDangKyDaoTaoTable, { laBoSungChoDuyet } from "./BoSungDangKyDaoTaoTable";
import InDangKyDaoTaoNam from './InDangKyDaoTaoNam';
import TrangThaiTongHopTag from "./TrangThaiTongHopTag";
import ViewDangKyDaoTaoTable from "./ViewDangKyDaoTaoTable";

/**
 * Người duyệt cuối cùng chỉ được chọn các chi tiết đăng ký đang chờ duyệt (đã chuyển văn phòng)
 */
const choPhepChonDuyetCuoi = (hocVien: any): boolean => hocVien.trangThaiChiTiet === trangThaiDangKyDaoTao.chuyenVanPhong;

const XemDotDangKyDaoTao = () => {
    let navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);

    const [activeTab, setActiveTab] = useState<string>(params.get("tab") || "1");
    const [lyDo, setLyDo] = useState<string>("");
    let id = params.get('id') || '0';
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [data, setData] = useState<any>({});
    const menu: any = menuHelper.checkMultiPermission([Links.DangKyDaoTao.ChiTiet, Links.DangKyDaoTao.PheDuyetTongHop]);
    const user = useSelector((state: any) => state.auth.currentUser);
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [noiDungTrinh, setNoiDungTrinh] = useState<string>('');
    const [confirmModal, setConfirmModal] = useState<any>({});
    // các chi tiết đăng ký đang được người duyệt cuối cùng chọn trong bảng
    const [dsChon, setDsChon] = useState<Array<any>>([]);
    // id các dòng dữ liệu lớp bổ sung đang được người duyệt cuối cùng chọn
    const [dsChonBoSung, setDsChonBoSung] = useState<Array<number>>([]);
    const [showBanHanh, setShowBanHanh] = useState(false);
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const props: UploadProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };
    const layCT = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            if (id > 0) {
                var detailData = await layChiTietDangKyDaoTaoNam(id);
                setData(detailData);
                // bảng tự bỏ chọn khi đổi bộ dữ liệu => đồng bộ lại danh sách chọn ở đây
                setDsChon([]);
                setDsChonBoSung([]);
                setNoiDungTrinh(detailData.noiDung || '');
                dispatch(hideLoadingScreen());
            }
        }
        catch (error: any) {
            toast.error("Đợt đăng ký đào tạo không tồn tại!");
            dispatch(hideLoadingScreen());
            navigate(Links.DangKyDaoTao.DanhSachNam);
        }
    }

    const xoa = async () => {
        try {
            dispatch(showLoadingScreen());
            await xoaDangKyDaoTaoNam(parseInt(id));
            dispatch(hideLoadingScreen());
            setOpenModalXoa(false);
            toast.success('Xóa Đợt đăng ký đào tạo thành công');
            navigate(Links.DangKyDaoTao.DanhSachNam);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error('Xóa Đợt đăng ký đào tạo không thành công! Vui lòng thử lại.');
        };
    };

    const handleLuuNoiDungTrinh = async (isTrinh: boolean) => {
        try {
            setLoading(true);
            dispatch(showLoadingScreen());
            const saveData = {
                id: parseInt(id),
                isTrinh: isTrinh,
                noiDung: noiDungTrinh
            };
            const updatedId = await luuNoiDungDangKyDaoTaoNam(saveData);
            toast.success(isTrinh ? "Trình tổng hợp đăng ký đào tạo thành công!" : "Lưu nội dung trình thành công!");
            setLoading(false);
            dispatch(hideLoadingScreen());
            if (updatedId > 0) {
                await layCT(updatedId);
            }
        } catch (error: any) {
            toast.error(error.message || isTrinh ? "Trình tổng hợp đăng ký đào tạo không thành công. Vui lòng thử lại" : "Lưu nội dung trình không thành công. Vui lòng thử lại");

            setLoading(false);
            dispatch(hideLoadingScreen());
        }
    };

    const handlePheDuyet = async (isDuyet: boolean) => {
        const saveData = {
            id: parseInt(id),
            isDuyet: isDuyet
        };
        setConfirmModal({
            isShowModal: true,
            title: isDuyet ? "Phê duyệt tổng hợp đăng ký đào tạo" : "Từ chối tổng hợp đăng ký đào tạo",
            content: isDuyet ? <>Bạn có muốn <strong>Duyệt</strong> bản tổng hợp đăng ký đào tạo này không? Hãy nhập nội dung (nếu có)</>
                : <>Bạn có muốn <strong>Từ chối</strong> bản tổng hợp đăng ký đào tạo này không? Hãy nhập nội dung (nếu có)</>,
            onSubmit: (currentLyDo: string) => submitPheDuyet(saveData, currentLyDo),
            showLyDo: true
        });
    };
    const submitPheDuyet = async (value: any, currentLyDo?: string) => {
        try {
            dispatch(showLoadingScreen());
            const updatedId =await pheDuyetTongHopDKDT({ ...value, lyDo: currentLyDo || lyDo });
            dispatch(showLoadingScreen());
            toast.success(value.isDuyet ? "Phê duyệt tổng hợp đăng ký đào tạo thành công" : 'Từ chối tổng hợp Đăng ký  đào tạo năm thành công!');
            if (updatedId > 0) {
                await layCT(updatedId);
            }
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error.message || "Vui lòng thử lại");
        };
    };
    const isBanHanh = menu[Links.DangKyDaoTao.ChiTiet] && [trangThaiTongHopDangKyDaoTao.pheDuyet].includes(data.trangThai);
    // isEditable: các trạng thái trả lại đều cho phép sửa
    const isEditable = menu[Links.DangKyDaoTao.ChiTiet] && ((
        [trangThaiTongHopDangKyDaoTao.khoiTao, trangThaiTongHopDangKyDaoTao.thuHoi,
         trangThaiTongHopDangKyDaoTao.phoCVPTraLai, trangThaiTongHopDangKyDaoTao.chanhVPTraLai, trangThaiTongHopDangKyDaoTao.giamDocTraLai
        ].includes(data.trangThai))
        || (data.trangThai == trangThaiTongHopDangKyDaoTao.phoGiamDocTraLai && data.idChanhVP == 0 && data.idPhoCVP == 0 ));

    const isPhoCVP = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idPhoCVP
        && ([trangThaiTongHopDangKyDaoTao.trinhPhoCVP, trangThaiTongHopDangKyDaoTao.chanhVPTraLai].includes(data.trangThai) ||
        (data.trangThai == trangThaiTongHopDangKyDaoTao.phoGiamDocTraLai && data.idChanhVP == 0)
        );

    const ischanhVP = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idChanhVP
        && [trangThaiTongHopDangKyDaoTao.trinhCVP, trangThaiTongHopDangKyDaoTao.phoGiamDocTraLai, trangThaiTongHopDangKyDaoTao.giamDocTraLai].includes(data.trangThai);

    const isPhoGiamDoc = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idPhoGiamDoc
        && [trangThaiTongHopDangKyDaoTao.trinhPhoGiamDoc, trangThaiTongHopDangKyDaoTao.giamDocTraLai].includes(data.trangThai);

    const isGiamDoc = menu[Links.DangKyDaoTao.PheDuyetTongHop] && user.idNhanVien == data.idGiamDoc
        && [trangThaiTongHopDangKyDaoTao.trinhGiamDoc].includes(data.trangThai);

    // người duyệt cuối cùng: theo thứ tự Giám đốc, Phó Giám đốc, Chánh VP, Phó CVP
    const idNguoiDuyetCuoi = [data.idGiamDoc, data.idPhoGiamDoc, data.idChanhVP, data.idPhoCVP].find(x => x > 0);
    const isNguoiDuyetCuoi = idNguoiDuyetCuoi > 0 && user.idNhanVien == idNguoiDuyetCuoi
        && (isGiamDoc || isPhoGiamDoc || ischanhVP || isPhoCVP);
    // các chi tiết đang chọn mà người duyệt cuối cùng được phép duyệt / từ chối
    const dsChonHopLe = dsChon.filter(choPhepChonDuyetCuoi);
    // các nhân viên trong dữ liệu lớp bổ sung đang chọn mà vẫn chờ duyệt
    const dsChonBoSungHopLe = dsChonBoSung.filter(idChiTiet =>
        (data.boSungs || []).some((x: any) => (x.nhanViens || []).some((nv: any) => nv.id === idChiTiet && laBoSungChoDuyet(nv))));

    /**
     * Mở popup xác nhận Duyệt / Từ chối các chi tiết đăng ký (hoặc dòng bổ sung) đang được chọn
     */
    const eventDuyetChiTiet = (isDuyet: boolean, laBoSung: boolean) => {
        const danhSachDuyet = laBoSung ? [] : dsChonHopLe.map(x => x.idChiTiet);
        const danhSachBoSung = laBoSung ? dsChonBoSungHopLe : [];
        const soLuong = danhSachDuyet.length + danhSachBoSung.length;
        if (soLuong === 0) {
            toast.warning("Vui lòng chọn ít nhất một lớp đang chờ duyệt");
            return;
        }
        setLyDo("");
        setConfirmModal({
            isShowModal: true,
            title: isDuyet ? "Duyệt chi tiết đăng ký đào tạo" : "Từ chối chi tiết đăng ký đào tạo",
            content: <>Bạn có muốn <strong>{isDuyet ? "Duyệt" : "Từ chối"}</strong> {soLuong} thông tin đã chọn không?</>,
            showLyDo: true,
            batBuocLyDo: !isDuyet,
            onSubmit: (currentLyDo: string) => duyetChiTiet(isDuyet, danhSachDuyet, danhSachBoSung, currentLyDo)
        });
    };

    const duyetChiTiet = async (isDuyet: boolean, danhSachDuyet: Array<number>, danhSachBoSung: Array<number>, currentLyDo?: string) => {
        dispatch(showLoadingScreen());
        try {
            await duyetChiTietTongHopDKDT({
                idDangKyDaoTaoNam: parseInt(id),
                isDuyet: isDuyet,
                lyDo: currentLyDo || lyDo,
                danhSachDuyet,
                danhSachBoSung
            });
            toast.success(isDuyet ? "Duyệt đăng ký đào tạo thành công" : "Từ chối đăng ký đào tạo thành công");
            setLyDo("");
            await layCT(parseInt(id));
        } catch (ex: any) {
            toast.error(ex?.message || "Thao tác không thành công");
        }
        dispatch(hideLoadingScreen());
    };

    /**
     * Nút Duyệt / Từ chối của người duyệt cuối cùng phía trên bảng
     */
    const renderNutDuyetChiTiet = (soLuong: number, laBoSung: boolean, goiY: string) => (
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <span style={{ color: "#8c8c8c" }}>{goiY}</span>
            <Button
                type="primary"
                icon={<CheckOutlined rev="" />}
                className="hrm-btn"
                disabled={soLuong === 0}
                onClick={() => eventDuyetChiTiet(true, laBoSung)}
            >
                Duyệt{soLuong > 0 ? ` (${soLuong})` : ""}
            </Button>
            <Button
                type="primary"
                danger
                icon={<CloseOutlined rev="" />}
                className="hrm-btn"
                disabled={soLuong === 0}
                onClick={() => eventDuyetChiTiet(false, laBoSung)}
            >
                Từ chối{soLuong > 0 ? ` (${soLuong})` : ""}
            </Button>
        </div>
    );
    useEffect(() => {
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
    }, []);

    useEffect(() => {
        if (showBanHanh && data?.id) {
            form.setFieldsValue({
                id: data.id,
                soVanBan: data.soVanBan || '',
                maVanBan: data.maVanBan || 'KH-QĐTPT',
                ngayKyVanBan: data.ngayKyVanBan != null ? dayjs(data.ngayKyVanBan) : null,
            });
        }
    }, [showBanHanh]);

    const onFinish = async (values: any) => {
        try {
            if (fileList.length === 0) {
                toast.error("Vui lòng đính kèm file ban hành!");
                return;
            }
            dispatch(showLoadingScreen());
            setLoading(true);

            var ngayKyVanBan = dateCommon.formatDate(values.ngayKyVanBan?.$d);
            var request: QDBLRequest = {
                files: fileList,
                id: values.id,
                soVanBan: values.soVanBan,
                maVanBan: values.maVanBan,
                ngayKyVanBan: ngayKyVanBan
            };
            await luuBanHanhDangKyDaoTao(request);
            setShowBanHanh(false);
            setLoading(false);
            dispatch(hideLoadingScreen());
            toast.success('Lưu file ban hành thành công!');
            await layCT(values.id);
        }
        catch (err: any) {
            setShowBanHanh(false);
            setLoading(false);
            dispatch(hideLoadingScreen());
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
    };
    const componentRef = useRef<any>(null);

    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [exportId, setExportId] = useState<number | null>(null);
    const [exportForm] = Form.useForm();

    const handleOpenExportModal = (id: number) => {
        setExportId(id);
        exportForm.setFieldsValue({
            soVanBan: data.soVanBan || '',
            maVanBan: data.maVanBan || 'KH-QĐTPT',
            ngayKyVanBan: data.ngayKyVanBan != null ? dayjs(data.ngayKyVanBan) : null,
        });
        setIsExportModalVisible(true);
    };

    const handleDownloadWord = async () => {
        try {
            const values = await exportForm.validateFields();
            if (exportId) {
                dispatch(showLoadingScreen());
                const response = await xuatKeHoachDaoTaoNam(exportId, values.soVanBan || '', values.maVanBan || '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `KeHoachDaoTao.docx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                dispatch(hideLoadingScreen());
                setIsExportModalVisible(false);
            }
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error("Tải file không thành công");
        }
    };
    const handleDownloadPhieuTrinh = async () => {
        try {
            const parsedId = parseInt(id);
            if (parsedId) {
                dispatch(showLoadingScreen());
                const response = await xuatPhieuTrinhDaoTaoNam(parsedId);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PhieuTrinhKeHoachDaoTao_${data?.nam ? dayjs(data.nam).format('YYYY') : ''}.docx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                dispatch(hideLoadingScreen());
            }
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error("Tải file không thành công");
        }
    };
    const printDangKyDaoTaoNam = useReactToPrint({
        content: () => componentRef.current,
    });
    return (
        <section style={{ paddingBottom: "60px" }}>
            {showBanHanh && <ModalTextForm title="Ban hành quyết định"
                hideFooter
                show={showBanHanh}
                handleClose={() => setShowBanHanh(false)}
            >
                <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item label="Số văn bản" name="soVanBan" required>
                        <Input placeholder="Nhập số văn bản" />
                    </Form.Item>
                    <Form.Item label="Mã văn bản" name="maVanBan" required>
                        <Input placeholder="Nhập mã văn bản" />
                    </Form.Item>
                    <Form.Item label="Ngày ký văn bản" name="ngayKyVanBan" required>
                        <DatePicker changeOnBlur={true} placeholder="Nhập ngày ký văn bản" allowClear={false} format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }} />
                    </Form.Item>
                    <Row>
                        <Col span="24">
                            <Upload {...props}>
                                <Button icon={<UploadOutlined rev="" />}>Thêm file ban hành</Button>
                            </Upload>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            <section style={{ display: 'none' }}>
                <div ref={componentRef} >
                    <InDangKyDaoTaoNam data={data} ></InDangKyDaoTaoNam>
                </div>
            </section>
            <ContentHeader title="Đợt đăng ký đào tạo" />
            {openModalXoa && <ModalTextForm show={openModalXoa}
                title="Xoá Đợt đăng ký đào tạo"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={() => xoa()}>
                Bạn có đồng ý xóa Đợt đăng ký đào tạo này không?
            </ModalTextForm>}

            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    if (confirmModal.batBuocLyDo && !lyDo.trim()) {
                        toast.warning("Vui lòng nhập lý do từ chối");
                        return;
                    }
                    if (confirmModal.onSubmit) confirmModal.onSubmit(lyDo);
                    setConfirmModal({ isShowModal: false });
                }}
            >
                <Row>
                    <Col span="24">
                        {confirmModal.content}
                    </Col>
                </Row>
                {
                    confirmModal.showLyDo &&
                    <Row>
                        <Col span="24">
                            {confirmModal.batBuocLyDo && <label>Lý do <span className="text-red">*</span></label>}
                            <Input.TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                }
            </ModalTextForm>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs activeKey={activeTab}
                            tabBarExtraContent={activeTab == 2 ?
                                <Space style={{ position: "fixed", zIndex: 1, right: "25px", top: "120px" }}>
                                    {isEditable &&
                                        <>
                                            <Button
                                                type="primary"
                                                icon={<SaveOutlined />}
                                                onClick={() => { handleLuuNoiDungTrinh(false) }}
                                                loading={loading}
                                            >
                                                Lưu
                                            </Button>

                                            <Button
                                                type="primary"
                                                icon={<SendOutlined />}
                                                onClick={() => { handleLuuNoiDungTrinh(true) }}
                                            >
                                                Lưu & Trình
                                            </Button>
                                        </>}
                                    {isBanHanh && <>
                                        <Button
                                            icon={<CheckOutlined rev="" />}
                                            htmlType="submit"
                                            className="hrm-btn-success"
                                            onClick={() => { setShowBanHanh(true); }}

                                        >
                                            Ban hành
                                        </Button>
                                    </>}
                                    {isPhoCVP && <>
                                        <Button
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(true) }}

                                        >
                                            Phê duyệt
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(false) }}

                                        >
                                            Từ chối
                                        </Button>
                                    </>}
                                    {ischanhVP && <>
                                        <Button
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(true) }}

                                        >
                                            Phê duyệt
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(false) }}

                                        >
                                            Từ chối
                                        </Button>
                                    </>}
                                    {isPhoGiamDoc && <>
                                        <Button
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(true) }}

                                        >
                                            Phê duyệt
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(false) }}

                                        >
                                            Từ chối
                                        </Button>
                                    </>}
                                    {isGiamDoc && <>
                                        <Button
                                            type="primary"
                                            icon={<SendOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(true) }}

                                        >
                                            Phê duyệt
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="hrm-btn-delete"
                                            icon={<CloseOutlined rev="" />}
                                            htmlType="submit"
                                            onClick={() => { handlePheDuyet(false) }}

                                        >
                                            Từ chối
                                        </Button>
                                    </>}
                                    {data.noiDung != null && <>
                                        <Button
                                            className="hrm-btn-print"
                                            icon=<PrinterOutlined rev="" />
                                            onClick={() => {
                                                printDangKyDaoTaoNam();
                                            }}
                                        >In phiếu trình
                                        </Button>
                                        <Button
                                            type="primary"
                                            icon=<DownloadOutlined rev="" />
                                            onClick={handleDownloadPhieuTrinh}
                                        >Tải phiếu trình
                                        </Button>
                                    </>}
                                    {data.trangThai >= trangThaiTongHopDangKyDaoTao.trinhPhoCVP && data.trangThai < trangThaiTongHopDangKyDaoTao.banHanh && <Button
                                        type="primary"
                                        icon=<DownloadOutlined rev="" />
                                        onClick={() => { handleOpenExportModal(parseInt(id)) }}
                                    >Tải Kế hoạch
                                    </Button>}
                                </Space> : null}
                            onChange={(key) => setActiveTab(key)} items={[
                            {
                                key: '1',
                                label: 'Thông tin chung',
                                children:
                                    <div className="card pt-3 pb-2">
                                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                                            <Row>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Tên đợt đăng ký</div>
                                                        <label><strong>{data?.ten}</strong></label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Năm</div>
                                                        <label>{dateCommon.formatDate(data?.nam, "yyyy")} </label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Thời gian đăng ký</div>
                                                        <label>{dateCommon.formatDate(data?.ngayBatDau)} - {dateCommon.formatDate(data?.ngayKetThuc)}</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idPhoCVP > 0}
                                                        >
                                                            Trình Phó Chánh Văn Phòng {data.idPhoCVP ? `(${data.tenPhoCVP})` : null}
                                                        </Checkbox>
                                                    </div>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idChanhVP > 0}
                                                        >
                                                            Trình Chánh Văn Phòng {data.idChanhVP ? `(${data.tenChanhVP})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idPhoGiamDoc > 0}
                                                        >
                                                            Trình Phó Giám đốc phụ trách VP {data.idPhoGiamDoc ? `(${data.tenPhoGiamDoc})` : null}
                                                        </Checkbox>
                                                    </div>
                                                    <div className="mb-1">
                                                        <Checkbox
                                                            checked={data.idGiamDoc > 0}
                                                        >
                                                            Trình Giám đốc đơn vị {data.idGiamDoc ? `(${data.tenGiamDoc})` : null}
                                                        </Checkbox>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Trạng thái</div>
                                                        <label>
                                                            <TrangThaiTongHopTag value={data.trangThai} />
                                                        </label>
                                                    </div>
                                                    {
                                                        (data.dsTaiLieu || []).length > 0 &&
                                                        <div className="mb-1">
                                                            <div>File đính kèm:</div>
                                                            {(data.dsTaiLieu || []).map((file: any, index: number) => (
                                                                <span key={index} style={{ marginRight: "5px", display: "inline-block", marginTop: "4px" }}>
                                                                    <a
                                                                        href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                        download={file.tenTep}
                                                                    >
                                                                        <Button
                                                                            className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                                            title={file.tenTep}
                                                                        >
                                                                            <i className="fa fa-download mr-2" />
                                                                            {shortFileName(file.tenTep)}
                                                                        </Button>
                                                                    </a>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <div className="card-outline">
                                                        {isEditable &&
                                                            <Row className="mt-1 mb-1">
                                                                <Col span="24">
                                                                    <FloatButton.Group
                                                                        trigger="hover"
                                                                        type="primary"
                                                                        style={{ right: 50, bottom: 80 }}
                                                                    >
                                                                        <FloatButton
                                                                            tooltip="Chỉnh sửa"
                                                                            className="hrm-btn-warning"
                                                                            icon={<EditOutlined rev="" />}
                                                                            onClick={() => {
                                                                                navigate(Links.DangKyDaoTao.ChiTiet + "?id=" + id);
                                                                            }}
                                                                        />
                                                                        <FloatButton
                                                                            tooltip="Xóa"
                                                                            className="hrm-btn-delete"
                                                                            icon={<DeleteOutlined rev="" />}
                                                                            onClick={() => setOpenModalXoa(true)}
                                                                        />

                                                                    </FloatButton.Group>
                                                                </Col>
                                                            </Row>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                            },
                            {
                                key: '2',
                                label: "Thông tin đăng ký",
                                children: (
                                    <div className="card pt-3 pb-2">
                                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                                            <Row gutter={16} align="middle">
                                                <Col span={24}>
                                                    <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                                                        <label>Tên đợt đăng ký:</label>
                                                        <span style={{ fontWeight: 600 }}>
                                                            {data?.ten}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row gutter={16} align="middle">
                                                <Col span={3}>
                                                    <div style={{ display: "flex", gap: 6 }}>
                                                        <label >Năm:</label>
                                                        <span style={{ fontWeight: 500 }}>
                                                            {dateCommon.formatDate(data?.nam, "yyyy")}
                                                        </span>
                                                    </div>
                                                </Col>

                                                <Col span={6}>
                                                    <div style={{ display: "flex", gap: 6 }}>
                                                        <label>Thời gian đăng ký:</label>
                                                        <span style={{ fontWeight: 500 }}>
                                                            {dateCommon.formatDate(data?.ngayBatDau)} - {dateCommon.formatDate(data?.ngayKetThuc)}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col span={4}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        <span style={{ margin: 0 }}>Trạng thái:</span>
                                                        <TrangThaiTongHopTag value={data.trangThai} />
                                                    </div>
                                                </Col>
                                                {
                                                    (data.dsTaiLieu || []).length > 0 &&
                                                    <Col span={11}>
                                                        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                                                            <label style={{ minWidth: "90px" }}>File đính kèm:</label>
                                                            {(data.dsTaiLieu || []).map((file: any, index: number) => (
                                                                <span key={index} style={{ fontWeight: 500 }}>
                                                                    <a
                                                                        href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                        download={file.tenTep}
                                                                    >
                                                                        <Button
                                                                            className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                                            title={file.tenTep}
                                                                        >
                                                                            <i className="fa fa-download mr-2" />
                                                                            {shortFileName(file.tenTep)}
                                                                        </Button>
                                                                    </a>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                }
                                            </Row>
                                            {data.trangThai == trangThaiTongHopDangKyDaoTao.banHanh  &&
                                            <Row gutter={16} align="middle">
                                                <Col span={3}>
                                                    <div style={{ display: "flex", gap: 6 }}>
                                                        <label>Số văn bản:</label>
                                                        <span style={{ fontWeight: 500 }}>
                                                                {data.soVanBan}/{data.maVanBan}
                                                        </span>
                                                    </div>
                                                </Col>

                                                <Col span={6}>
                                                    <div style={{ display: "flex", gap: 6 }}>
                                                        <label>Ngày ký:</label>
                                                        <span style={{ fontWeight: 500 }}>
                                                            {dateCommon.formatDate(data?.ngayKyVanBan)}
                                                        </span>
                                                    </div>
                                                </Col>
                                                {
                                                    (data.taiLieuBanHanh || []).length > 0 &&
                                                    <Col span={9}>
                                                        <div style={{ display: "flex", gap: 6 }}>
                                                            <label>File ban hành:</label>
                                                            {(data.taiLieuBanHanh || []).map((file, index) => (
                                                                <span key={index} style={{ fontWeight: 500 }}>
                                                                    <a
                                                                        href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                                        download={file.tenTep}
                                                                    >
                                                                        <Button
                                                                            className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                                            title={file.tenTep}
                                                                        >
                                                                            <i className="fa fa-download mr-2" />
                                                                            {shortFileName(file.tenTep)}
                                                                        </Button>
                                                                    </a>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                }
                                                </Row>
                                            }
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <div style={{ display: "flex", flexDirection: "column", marginBottom: 8 }}>
                                                        <h5
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#1f1f1f",
                                                                margin: 0,
                                                                fontSize: 14
                                                            }}
                                                        >
                                                            Nội dung
                                                        </h5>

                                                        <div
                                                            style={{
                                                                width: 70,
                                                                height: 2,
                                                                backgroundColor: "#1890ff",
                                                                marginTop: 4,
                                                                borderRadius: 2
                                                            }}
                                                        />
                                                    </div>
                                                    {isEditable ? <Summernote
                                                        value={noiDungTrinh}
                                                        onChange={(content) => setNoiDungTrinh(content)}
                                                        placeholder="Nhập nội dung trình..."
                                                        height={350}
                                                    /> : data.noiDung ?
                                                        <div className="document">
                                                            <div dangerouslySetInnerHTML={{ __html: data.noiDung || '' }} />
                                                            <div className="signature">
                                                                {/* Hàng 1: Người trình + Phó CVP (nếu có) + Chánh VP (nếu có) */}
                                                                {(() => {
                                                                    const hasPhoCVP = data.idPhoCVP > 0;
                                                                    const hasChanhVP = data.idChanhVP > 0;
                                                                    const cols: React.ReactNode[] = [];
                                                                    
                                                                    const count = 1 + (hasPhoCVP ? 1 : 0) + (hasChanhVP ? 1 : 0);
                                                                    const span = count === 3 ? 8 : count === 2 ? 12 : 24;

                                                                    // Cột Chánh VP (nếu có)
                                                                    if (hasChanhVP) {
                                                                        cols.push(
                                                                            <Col key="cvp" span={span} className="sign-block">
                                                                                {data?.lanhDaoPhong != null ? (
                                                                                    <>
                                                                                        <div className="title">CHÁNH VĂN PHÒNG</div>
                                                                                        <div className="signed">Đã ký</div>
                                                                                        <div className="time">
                                                                                            {dateCommon.formatDate(data?.lanhDaoPhong.thoiGian, "HH:mm dd/MM/yyyy")}
                                                                                        </div>
                                                                                        <div className="name">{data?.lanhDaoPhong.tenNguoiKy}</div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="title">CHÁNH VĂN PHÒNG</div>
                                                                                        <div className="name">{data?.tenChanhVP || ''}</div>
                                                                                    </>
                                                                                )}
                                                                            </Col>
                                                                        );
                                                                    }

                                                                    // Cột Phó CVP (nếu có)
                                                                    if (hasPhoCVP) {
                                                                        const phoCVPTitle = !hasChanhVP
                                                                            ? <><span>KT. CVP</span><br /><span>Phó Chánh VP</span></>
                                                                            : 'PHÓ CHÁNH VĂN PHÒNG';
                                                                        cols.push(
                                                                            <Col key="phocvp" span={span} className="sign-block">
                                                                                {data?.phoCVP != null ? (
                                                                                    <>
                                                                                        <div className="title">{phoCVPTitle}</div>
                                                                                        <div className="signed">Đã ký</div>
                                                                                        <div className="time">
                                                                                            {dateCommon.formatDate(data?.phoCVP.thoiGian, "HH:mm dd/MM/yyyy")}
                                                                                        </div>
                                                                                        <div className="name">{data?.phoCVP.tenNguoiKy}</div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="title">{phoCVPTitle}</div>
                                                                                        <div className="name">{data?.tenPhoCVP || ''}</div>
                                                                                    </>
                                                                                )}
                                                                            </Col>
                                                                        );
                                                                    }

                                                                    // Cột Người trình
                                                                    cols.push(
                                                                        <Col key="nguoitrinh" span={span} className="sign-block">
                                                                            {data?.nguoiTrinh != null ? (
                                                                                <>
                                                                                    <div className="title">NGƯỜI TRÌNH</div>
                                                                                    <div className="signed">Đã ký</div>
                                                                                    <div className="time">
                                                                                        {dateCommon.formatDate(data?.nguoiTrinh.thoiGian, "HH:mm dd/MM/yyyy")}
                                                                                    </div>
                                                                                    <div className="name">{data.nguoiTrinh.tenNguoiKy}</div>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <div className="title">NGƯỜI TRÌNH</div>
                                                                                    <div className="name">{data?.tenNguoiTrinh || ''}</div>
                                                                                </>
                                                                            )}
                                                                        </Col>
                                                                    );

                                                                    return <Row gutter={8}>{cols}</Row>;
                                                                })()}

                                                                {/* Hàng 2: Ý kiến Phó Giám đốc (nếu có) */}
                                                                {data.idPhoGiamDoc > 0 &&
                                                                    <Row gutter={8} style={{ marginTop: "24px" }}>
                                                                        <Col span={24} className="sign-block">
                                                                            {data?.phoGiamDoc != null ? (
                                                                                <>
                                                                                    <div className="title">Ý KIẾN CỦA PHÓ GIÁM ĐỐC PHỤ TRÁCH VĂN PHÒNG</div>
                                                                                    <div className="signed">{data.phoGiamDoc.yKien}</div>
                                                                                    <div className="signed">Đã ký</div>
                                                                                    <div className="time">
                                                                                        {dateCommon.formatDate(data?.phoGiamDoc.thoiGian, "HH:mm dd/MM/yyyy")}
                                                                                    </div>
                                                                                    <div className="name">{data.phoGiamDoc.tenNguoiKy}</div>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <div className="title">Ý KIẾN CỦA PHÓ GIÁM ĐỐC PHỤ TRÁCH VĂN PHÒNG</div>
                                                                                    <div className="name">{data?.tenPhoGiamDoc || ''}</div>
                                                                                </>
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                }

                                                                {/* Hàng 3: Phê duyệt của Giám đốc đơn vị */}
                                                                <Row gutter={8} style={{ marginTop: "24px" }}>
                                                                    <Col span={24} className="sign-block">
                                                                        <div className="title">PHÊ DUYỆT CỦA PHỤ TRÁCH ĐIỀU HÀNH</div>
                                                                        {data.lanhDaoQuy != null ? <>
                                                                            <div className="signed">{data.lanhDaoQuy.yKien}</div>
                                                                            <div className="signed">Đã ký</div>
                                                                            <div className="time">
                                                                                {dateCommon.formatDate(data?.lanhDaoQuy.thoiGian, "HH:mm dd/MM/yyyy")}
                                                                            </div>
                                                                            <div className="name">{data.lanhDaoQuy.tenNguoiKy}</div>
                                                                        </> : <>
                                                                            <div className="name">{data?.tenGiamDoc || ''}</div>
                                                                        </>}
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            </div> : null
                                                    }
                                                </Col>
                                                <Col span={24}>
                                                    <div style={{ display: "flex", flexDirection: "column", marginBottom: 8 }}>
                                                        <h5
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#1f1f1f",
                                                                margin: 0,
                                                                fontSize: 14
                                                            }}
                                                        >
                                                            Danh sách đăng ký
                                                        </h5>

                                                        <div
                                                            style={{
                                                                width: 140,
                                                                height: 2,
                                                                backgroundColor: "#1890ff",
                                                                marginTop: 4,
                                                                borderRadius: 2
                                                            }}
                                                        />
                                                    </div>
                                                    {
                                                        // người duyệt cuối cùng chọn các chi tiết để Duyệt / Từ chối
                                                        isNguoiDuyetCuoi && renderNutDuyetChiTiet(dsChonHopLe.length, false,
                                                            'Chọn các nhân viên ở cột "Đối tượng" để duyệt hoặc từ chối')
                                                    }
                                                    <ViewDangKyDaoTaoTable dataTable={data?.flats} isMoLop={data?.trangThai == trangThaiTongHopDangKyDaoTao.banHanh}
                                                        coTheGop={isEditable}
                                                        onSelectedChange={isNguoiDuyetCuoi ? setDsChon : undefined}
                                                        choPhepChon={isNguoiDuyetCuoi ? choPhepChonDuyetCuoi : undefined}
                                                        onReload={() => layCT(parseInt(id))}/>
                                                    <div style={{ display: "flex", flexDirection: "column", marginBottom: 8, marginTop: 16 }}>
                                                        <h5
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#1f1f1f",
                                                                margin: 0,
                                                                fontSize: 14
                                                            }}
                                                        >
                                                            Dữ liệu lớp đào tạo về chính trị, GDQP An ninh bổ sung
                                                        </h5>

                                                        <div
                                                            style={{
                                                                width: 140,
                                                                height: 2,
                                                                backgroundColor: "#1890ff",
                                                                marginTop: 4,
                                                                borderRadius: 2
                                                            }}
                                                        />
                                                    </div>
                                                    {
                                                        isNguoiDuyetCuoi && renderNutDuyetChiTiet(dsChonBoSungHopLe.length, true,
                                                            'Chọn các nhân viên ở cột "Đối tượng" để duyệt hoặc từ chối')
                                                    }
                                                    <BoSungDangKyDaoTaoTable
                                                        data={data?.boSungs || []}
                                                        idDangKyDaoTaoNam={parseInt(id)}
                                                        trangThai={data.trangThai}
                                                        isEditable={isEditable}
                                                        coTheDuyet={isNguoiDuyetCuoi}
                                                        dsChon={dsChonBoSung}
                                                        onSelectedChange={setDsChonBoSung}
                                                        onReload={() => layCT(parseInt(id))}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )
                            },
                            {
                                key: '3',
                                label: "Lịch sử thao tác",
                                children: <LogNguoiDungTable data={data?.logs} />
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Modal
                title="Xuất file Kế hoạch đào tạo"
                open={isExportModalVisible}
                onOk={handleDownloadWord}
                onCancel={() => setIsExportModalVisible(false)}
                okText="Xuất file"
                cancelText="Hủy"
            >
                <Form form={exportForm} layout="vertical">
                    <Form.Item label="Số văn bản" name="soVanBan">
                        <Input placeholder="Nhập số văn bản (nếu có)" />
                    </Form.Item>
                    <Form.Item label="Mã văn bản" name="maVanBan">
                        <Input placeholder="Nhập mã văn bản" />
                    </Form.Item>
                    <Form.Item label="Ngày ký văn bản" name="ngayKyVanBan">
                        <DatePicker changeOnBlur={true} placeholder="Nhập ngày ký văn bản (nếu có)" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }} />
                    </Form.Item>
                </Form>
            </Modal>
        </section>
    )
}

export default XemDotDangKyDaoTao;